export default __webpack_public_path__ + "media/images/logos/plus-divide-blue-49e47c678bb9df47f6680813bdcb38a4.svg";